import React from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const BackToTopButton = (props) => {
    const scrollToTop = () => {
        if (props.element && props.element.current) {
            props.element.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    };
    return (React.createElement("div", { className: "back-to-top", onClick: scrollToTop },
        React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HISTORY_TOP })));
};
